module.exports = __webpack_public_path__ + "img/delivery-boy.5f343347.png";